import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared/shared.module';
import { CommonModule } from '@angular/common';
import * as fromComponents from './components';
import { FrameReturnsCartRoutingModule } from '@app/frame-returns-cart/frame-returns-cart-routing.module';
import { FrameReturnsCartComponent } from '@app/frame-returns-cart/frame-returns-cart.component';
/**
 * ShoppingCartModule
 */
@NgModule({
    imports: [SharedModule, FrameReturnsCartRoutingModule, CommonModule],
    declarations: [FrameReturnsCartComponent, ...fromComponents.components],
    providers: [],
    exports: [FrameReturnsCartComponent, ...fromComponents.components]
})
export class FrameReturnsCartModule {}
